module.exports = __webpack_public_path__ + "static/media/cactuscan.9ef3cb72.png";